const CollectionUpdater = {
  updateProductGrid(url) {
    return fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('#product-grid');
        const currentSection = document.querySelector('#product-grid');

        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }

        const newFacets = doc.querySelector('mm-facets');
        const currentFacets = document.querySelector('mm-facets');
        if (newFacets && currentFacets) {
          const activeCount = newFacets.getAttribute('active-filters') || '0';
          currentFacets.setAttribute('active-filters', activeCount);
        }
      })
      .catch(err => console.error('Failed to update collection:', err));
  }
};


class MMSortDropdown extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    const options = JSON.parse(this.getAttribute('options') || '[]');
    let currentValue = this.getAttribute('current-value') || '';

    if (!currentValue) {
      const urlParams = new URLSearchParams(window.location.search);
      currentValue = urlParams.get('sort_by') || '';
    }

    this.innerHTML = `
      <div class="sort-dropdown">
        <button type="button" class="sort-dropdown__trigger" aria-haspopup="listbox" aria-expanded="false">
          <span class="sort-dropdown__label">SORT BY</span>
          <img src="https://cdn.shopify.com/s/files/1/0506/0981/5718/files/Vector_4.svg?v=1766167980" class="trigger-icon" />
        </button>
        <ul class="sort-dropdown__menu" role="listbox">
          ${options.map(opt => `
            <li role="option" data-value="${opt.value}" class="sort-dropdown__option ${opt.value === currentValue ? 'is-selected' : ''}">
              <span>${opt.name}</span>
              ${opt.value === currentValue ? `
                <svg class="sort-dropdown__check" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              ` : ''}
            </li>
          `).join('')}
        </ul>
      </div>
    `;

    this.trigger = this.querySelector('.sort-dropdown__trigger');
    this.menu = this.querySelector('.sort-dropdown__menu');
    this.options = this.querySelectorAll('.sort-dropdown__option');

    this.trigger.addEventListener('click', () => this.toggle());

    this.options.forEach(opt => {
      opt.addEventListener('click', (e) => this.selectOption(e.currentTarget));
    });

    document.addEventListener('click', (e) => this.handleOutsideClick(e));
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.trigger.setAttribute('aria-expanded', this.isOpen);
    this.menu.classList.toggle('is-open', this.isOpen);
  }

  selectOption(optionEl) {
    const value = optionEl.getAttribute('data-value');
    const name = optionEl.querySelector('span').textContent;

    this.options.forEach(opt => {
      opt.classList.remove('is-selected');
      const check = opt.querySelector('.sort-dropdown__check');
      if (check) check.remove();
    });

    optionEl.classList.add('is-selected');
    optionEl.insertAdjacentHTML('beforeend', `
      <svg class="sort-dropdown__check" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `);

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set('sort_by', value);
    const newUrl = `${url.pathname}?${params.toString()}`;
    window.history.pushState({}, '', newUrl);

    CollectionUpdater.updateProductGrid(newUrl).then(() => {
      this.dispatchEvent(new CustomEvent('sort-change', {
        bubbles: true,
        detail: { value, name }
      }));
    });

    this.toggle();
  }

  handleOutsideClick(e) {
    if (this.isOpen && !this.contains(e.target)) {
      this.toggle();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
}

customElements.define('mm-sort-dropdown', MMSortDropdown);

class MMFacets extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    const filters = JSON.parse(this.getAttribute('filters') || '[]');
    const activeFilters = this.getAttribute('active-filters') || '0';

    this.innerHTML = `
      <button type="button" class="facets-trigger" aria-label="Open filters">
        <img src="https://cdn.shopify.com/s/files/1/0506/0981/5718/files/mage_filter.svg?v=1766168323" class="trigger-icon" />
        <span class="sort-dropdown__label">FILTERS</span>
        ${activeFilters > 0 ? `<span class="facets-badge">${activeFilters}</span>` : ''}
      </button>

      <div class="facets-drawer" aria-hidden="true">
        <div class="facets-overlay"></div>
        <div class="facets-content">
          <div class="facets-header">
            <div class="fc-header">
              <img src="https://cdn.shopify.com/s/files/1/0506/0981/5718/files/mage_filter.svg?v=1766168323" class="trigger-icon desktop-only" />
              <h2>Filters</h2>
            </div>
            <button type="button" class="facets-close" aria-label="Close filters">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>

          <div class="facets-body">
            ${this.renderFilters(filters)}
          </div>

          <div class="facets-footer">
            <button type="button" class="facets-clear">Clear all</button>
            <button type="button" class="facets-apply">Apply filters</button>
          </div>
        </div>
      </div>
    `;

    this.trigger = this.querySelector('.facets-trigger');
    this.drawer = this.querySelector('.facets-drawer');
    this.overlay = this.querySelector('.facets-overlay');
    this.closeBtn = this.querySelector('.facets-close');
    this.clearBtn = this.querySelector('.facets-clear');
    this.applyBtn = this.querySelector('.facets-apply');

    this.setupEventListeners();
    this.loadActiveFiltersFromURL();
  }

  renderFilters(filters) {
    if (!filters || filters.length === 0) {
      return '<p class="facets-empty">No filters available</p>';
    }

    return filters.map(filter => {
      if (filter.type === 'price_range') {
        return this.renderPriceFilter(filter);
      }
      return this.renderListFilter(filter);
    }).join('');
  }

  renderListFilter(filter) {
    const isAvailability = filter.param_name === 'filter.v.availability' || filter.label.toLowerCase().includes('availability');

    if (isAvailability) {
      const inStockValue = filter.values.find(v => v.value === '1' || v.label.toLowerCase().includes('in stock'));
      if (!inStockValue) return '';

      return `
        <div class="facets-group facets-group--no-accordion">
          <div class="facets-group__options is-open">
            <label class="facets-option">
              <span>In stock Only</span>
              <input
                type="checkbox"
                name="${filter.param_name}"
                value="${inStockValue.value}"
                ${inStockValue.active ? 'checked' : ''}
              />
            </label>
          </div>
        </div>
      `;
    }

    return `
      <div class="facets-group facets-group--accordion">
        <button type="button" class="facets-group__title" aria-expanded="false">
          <h3>${filter.label}</h3>
          <span class="facets-group__plus-minus">
            <svg class="plus-icon" viewBox="0 0 20 20" width="16" height="16">
              <path d="M10 4V16M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <svg class="minus-icon" viewBox="0 0 20 20" width="16" height="16">
              <path d="M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
        </button>
        <div class="facets-group__options">
          ${filter.values.map(value => `
            <label class="facets-option">
              <input
                type="checkbox"
                name="${filter.param_name}"
                value="${value.value}"
                ${value.active ? 'checked' : ''}
              />
              <span>${value.label}</span>
              <span class="facets-option__count">(${value.count})</span>
            </label>
          `).join('')}
        </div>
      </div>
    `;
  }

  renderPriceFilter(filter) {
    const minVal = filter.range_min || 0;
    const maxVal = Math.ceil(filter.range_max) || 1000;

    return `
      <div class="facets-group facets-group--accordion">
        <button type="button" class="facets-group__title" aria-expanded="false">
          <h3>${filter.label}</h3>
          <span class="facets-group__plus-minus">
            <svg class="plus-icon" viewBox="0 0 20 20" width="16" height="16">
              <path d="M10 4V16M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <svg class="minus-icon" viewBox="0 0 20 20" width="16" height="16">
              <path d="M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </span>
        </button>
        <div class="facets-group__options">
          <div class="facets-price">
            <div class="facets-price__values">
              <span class="facets-price__value" data-type="min">${minVal}</span>
              <span class="facets-price__separator">-</span>
              <span class="facets-price__value" data-type="max">${maxVal}</span>
            </div>
            <div class="facets-price__sliders">
              <input
                type="range"
                name="filter.v.price.gte"
                min="${minVal}"
                max="${maxVal}"
                value="${minVal}"
                class="facets-price__slider facets-price__slider--min"
                data-min="${minVal}"
                data-max="${maxVal}"
              />
              <input
                type="range"
                name="filter.v.price.lte"
                min="${minVal}"
                max="${maxVal}"
                value="${maxVal}"
                class="facets-price__slider facets-price__slider--max"
                data-min="${minVal}"
                data-max="${maxVal}"
              />
            </div>
          </div>
        </div>
      </div>
    `;
  }

  setupAccordionListeners() {
    this.querySelectorAll('.facets-group--accordion .facets-group__title').forEach(title => {
      title.addEventListener('click', () => {
        const options = title.closest('.facets-group').querySelector('.facets-group__options');
        const plusMinus = title.querySelector('.facets-group__plus-minus');
        const plusIcon = plusMinus.querySelector('.plus-icon');
        const minusIcon = plusMinus.querySelector('.minus-icon');
        const isExpanded = title.getAttribute('aria-expanded') === 'true';

        title.setAttribute('aria-expanded', !isExpanded);

        if (isExpanded) {
          options.classList.remove('is-open');
          plusIcon.style.display = 'block';
          minusIcon.style.display = 'none';
        } else {
          options.classList.add('is-open');
          plusIcon.style.display = 'none';
          minusIcon.style.display = 'block';
        }
      });
    });
  }

  setupEventListeners() {
    this.trigger.addEventListener('click', () => this.open());
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    this.clearBtn.addEventListener('click', () => this.clearFilters());
    this.applyBtn.addEventListener('click', () => this.applyFilters());

    this.querySelectorAll('input[type="checkbox"]').forEach(input => {
      input.addEventListener('change', () => this.applyFilters());
    });

    this.setupPriceSliders();
    this.setupAccordionListeners();
  }

  setupPriceSliders() {
    const minSlider = this.querySelector('.facets-price__slider--min');
    const maxSlider = this.querySelector('.facets-price__slider--max');
    const minValueDisplay = this.querySelector('.facets-price__value[data-type="min"]');
    const maxValueDisplay = this.querySelector('.facets-price__value[data-type="max"]');

    if (!minSlider || !maxSlider) return;

    const updateSliders = () => {
      let minVal = parseInt(minSlider.value);
      let maxVal = parseInt(maxSlider.value);

      if (minVal >= maxVal) {
        minVal = maxVal - 1;
        minSlider.value = minVal;
      }

      if (minValueDisplay) minValueDisplay.textContent = `${minVal}`;
      if (maxValueDisplay) maxValueDisplay.textContent = `${maxVal}`;

      this.updateSliderFill(minSlider, maxSlider);
    };

    minSlider.addEventListener('input', updateSliders);
    maxSlider.addEventListener('input', updateSliders);
    minSlider.addEventListener('change', () => this.applyFilters());
    maxSlider.addEventListener('change', () => this.applyFilters());

    this.updateSliderFill(minSlider, maxSlider);
  }

  updateSliderFill(minSlider, maxSlider) {
    const min = parseInt(minSlider.min);
    const max = parseInt(minSlider.max);
    const minVal = parseInt(minSlider.value);
    const maxVal = parseInt(maxSlider.value);

    const minPercent = ((minVal - min) / (max - min)) * 100;
    const maxPercent = ((maxVal - min) / (max - min)) * 100;

    const track = this.querySelector('.facets-price__sliders');
    if (track) {
      track.style.setProperty('--min-percent', `${minPercent}%`);
      track.style.setProperty('--max-percent', `${maxPercent}%`);
    }
  }

  loadActiveFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    this.querySelectorAll('input[type="checkbox"]').forEach(input => {
      const paramValues = urlParams.getAll(input.name);
      input.checked = paramValues.includes(input.value);
    });

    const minPrice = urlParams.get('filter.v.price.gte');
    const maxPrice = urlParams.get('filter.v.price.lte');
    const minSlider = this.querySelector('.facets-price__slider--min');
    const maxSlider = this.querySelector('.facets-price__slider--max');
    const minValueDisplay = this.querySelector('.facets-price__value[data-type="min"]');
    const maxValueDisplay = this.querySelector('.facets-price__value[data-type="max"]');

    if (minSlider && minPrice) {
      minSlider.value = minPrice;
      if (minValueDisplay) minValueDisplay.textContent = minPrice;
    }
    if (maxSlider && maxPrice) {
      maxSlider.value = maxPrice;
      if (maxValueDisplay) maxValueDisplay.textContent = maxPrice;
    }

    if (minSlider && maxSlider) this.updateSliderFill(minSlider, maxSlider);
  }

  open() {
    this.isOpen = true;
    this.drawer.setAttribute('aria-hidden', 'false');
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.isOpen = false;
    this.drawer.setAttribute('aria-hidden', 'true');
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  clearFilters() {
    this.querySelectorAll('input[type="checkbox"]').forEach(input => input.checked = false);

    const minSlider = this.querySelector('.facets-price__slider--min');
    const maxSlider = this.querySelector('.facets-price__slider--max');
    const minDisplay = this.querySelector('.facets-price__value[data-type="min"]');
    const maxDisplay = this.querySelector('.facets-price__value[data-type="max"]');

    if (minSlider && maxSlider) {
      const minVal = minSlider.getAttribute('data-min');
      const maxVal = maxSlider.getAttribute('data-max');

      minSlider.value = minVal;
      maxSlider.value = maxVal;
      if (minDisplay) minDisplay.textContent = minVal;
      if (maxDisplay) maxDisplay.textContent = maxVal;
      this.updateSliderFill(minSlider, maxSlider);
    }

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    for (const key of [...params.keys()]) {
      if (key.startsWith('filter.')) params.delete(key);
    }

    const cleanUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.pushState({}, '', cleanUrl);

    CollectionUpdater.updateProductGrid(cleanUrl).then(() => {
      this.close();
      this.dispatchEvent(new CustomEvent('filters-change', {
        bubbles: true,
        detail: { url: cleanUrl, params: Object.fromEntries(params) }
      }));
    });
  }

  applyFilters() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    for (const key of [...params.keys()]) {
      if (key.startsWith('filter.')) params.delete(key);
    }

    this.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
      params.append(input.name, input.value);
    });

    const minSlider = this.querySelector('.facets-price__slider--min');
    const maxSlider = this.querySelector('.facets-price__slider--max');

    if (minSlider && minSlider.value !== minSlider.getAttribute('data-min')) {
      params.set('filter.v.price.gte', minSlider.value);
    }
    if (maxSlider && maxSlider.value !== maxSlider.getAttribute('data-max')) {
      params.set('filter.v.price.lte', maxSlider.value);
    }

    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.pushState({}, '', newUrl);

    CollectionUpdater.updateProductGrid(newUrl).then(() => {
      this.close();
      this.dispatchEvent(new CustomEvent('filters-change', {
        bubbles: true,
        detail: { url: newUrl, params: Object.fromEntries(params) }
      }));
    });
  }

  disconnectedCallback() {
    document.body.style.overflow = '';
  }
}

customElements.define('mm-facets', MMFacets);